import { DirectiveOptions } from 'vue';
import { handlePasteEvent, EditableCell, PasteResult } from '@/utils/excel-paste';

interface ExcelPasteBinding {
  tableData: any;
  editableCells: EditableCell[];
  startCell: EditableCell | null;
  onPasteSuccess?: (result: PasteResult) => void;
  onPasteError?: (result: PasteResult) => void;
  componentHandlesPaste?: boolean;
}

export const excelPaste: DirectiveOptions = {
  bind(el: HTMLElement, binding) {
    const options = binding.value as ExcelPasteBinding;
    
    if (!options) {
      console.warn('Excel paste directive requires options');
      return;
    }

    const handlePaste = (event: ClipboardEvent) => {
      if (options.componentHandlesPaste) {
        console.log('🎯 Directive: component handles paste, skipping');
        return;
      }

      event.preventDefault();
      
      console.log('🎯 Directive handlePaste called');
      console.log('🎯 startCell:', options.startCell);
      console.log('🎯 editableCells length:', options.editableCells?.length);
      
      const result = handlePasteEvent(
        event,
        options.tableData,
        options.editableCells,
        options.startCell
      );

      if (result) {
        if (result.success) {
          if (options.onPasteSuccess) {
            options.onPasteSuccess(result);
          }
        } else {
          if (options.onPasteError) {
            options.onPasteError(result);
          }
        }
      }
    };

    // Сохраняем обработчик в элементе для последующего удаления
    (el as any)._excelPasteHandler = handlePaste;
    
    el.addEventListener('paste', handlePaste);
  },

  update(el: HTMLElement, binding) {
    // Обновляем опции при изменении binding
    const options = binding.value as ExcelPasteBinding;
    console.log('🔄 Directive update called, startCell:', options?.startCell?.dataField || 'null');
    if (options) {
      (el as any)._excelPasteOptions = options;
    }
  },

  unbind(el: HTMLElement) {
    const handler = (el as any)._excelPasteHandler;
    if (handler) {
      el.removeEventListener('paste', handler);
      delete (el as any)._excelPasteHandler;
    }
  }
}; 